import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    approveFunc: PropTypes.func,
    approveButtonName: PropTypes.string,
    open: PropTypes.bool,
  },

  /**
   * コンポーネントマウント時の処理
   */
  componentDidMount() {
    if (this.props.open) {
      this.openModal();
    }
  },

  /**
   * モーダルを開く処理
   */
  openModal() {
    $(`#${this.props.id}`).modal({ backdrop: "static" });
  },

  /**
   * モーダルを閉じる処理
   */
  closeModal() {
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    $(`#${this.props.id}`).modal("hide");
  },

  /**
   * ボタン押下時の処理
   */
  handleApproveButton() {
    if (this.props.approveFunc != undefined) {
      this.props.approveFunc();
    }
    this.closeModal();
  },

  render() {
    return (
      <div className="modal fade" id={this.props.id}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{this.props.title}</h4>
            </div>
            <div className="modal-body">
              <p>{this.props.content}</p>
            </div>
            <div className="modal-footer">
              <a
                className="btn btn-success"
                style={{ color: "white" }}
                onClick={this.handleApproveButton}
              >
                {this.props.approveButtonName || "OK"}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
